(function () {
  /*
   * ==========================================
   * PRODUCT SLIDER
   * ==========================================
   */

  class ProductSlider {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.new-arrivals-slider__track');
      this.prevBtn = el.querySelector('.new-arrivals-slider__arrow--prev');
      this.nextBtn = el.querySelector('.new-arrivals-slider__arrow--next');

      if (!this.track) return;

      this.prevBtn &&
        this.prevBtn.addEventListener('click', () => this.scrollByCards(-1));

      this.nextBtn &&
        this.nextBtn.addEventListener('click', () => this.scrollByCards(1));

      this.track.addEventListener('scroll', () => this.updateArrowState());

      window.addEventListener('resize', () => this.updateArrowState());

      this.updateArrowState();
    }

    scrollByCards(direction) {
      const card = this.track.querySelector(
        '.new-arrivals-slider__card'
      );

      if (!card) return;

      const cardWidth = card.getBoundingClientRect().width + 22;

      this.track.scrollBy({
        left: cardWidth * 2 * direction,
        behavior: 'smooth'
      });
    }

    updateArrowState() {
      if (!this.track) return;

      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = this.track;

      if (this.prevBtn) {
        this.prevBtn.disabled = scrollLeft <= 4;
      }

      if (this.nextBtn) {
        this.nextBtn.disabled =
          scrollLeft + clientWidth >= scrollWidth - 4;
      }
    }
  }

  /*
   * Initialize all sliders
   */
  function initSliders(container = document) {
    if (!container || !container.querySelectorAll) return;

    container
      .querySelectorAll('.new-arrivals-slider')
      .forEach((el) => {
        // Prevent duplicate initialization
        if (el.dataset.productSliderInitialized === 'true') {
          return;
        }

        el.dataset.productSliderInitialized = 'true';

        new ProductSlider(el);
      });
  }

  /*
   * Initial page load
   */
  initSliders();

  /*
   * Shopify Theme Editor
   */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initSliders(event.target);
      }
    );
  }


  /*
   * ==========================================
   * QUICK VIEW
   * ==========================================
   */

  /*
   * Prevent Quick View from being initialized
   * more than once if this JS file is loaded
   * multiple times.
   */
  if (window.NewArrivalsQuickViewInitialized) {
    return;
  }

  window.NewArrivalsQuickViewInitialized = true;


  const modal = document.getElementById('quick-view-modal');

  if (!modal) return;

  const imageEl = modal.querySelector(
    '.quick-view-modal__image'
  );

  const thumbsEl = modal.querySelector(
    '[data-qv-thumbs]'
  );

  const titleEl = modal.querySelector(
    '.quick-view-modal__title'
  );

  const priceEl = modal.querySelector(
    '.quick-view-modal__price'
  );

  const variantsEl = modal.querySelector(
    '.quick-view-modal__variants'
  );

  const qtyEl = modal.querySelector(
    '.quick-view-modal__qty'
  );

  const atcBtn = modal.querySelector(
    '.quick-view-modal__atc'
  );

  const atcText = modal.querySelector(
    '.quick-view-modal__atc-text'
  );

  const messageEl = modal.querySelector(
    '.quick-view-modal__message'
  );

  const viewFullEl = modal.querySelector(
    '.quick-view-modal__view-full'
  );


  /*
   * Make sure required Quick View elements exist
   */
  if (
    !imageEl ||
    !thumbsEl ||
    !titleEl ||
    !priceEl ||
    !variantsEl ||
    !qtyEl ||
    !atcBtn ||
    !atcText ||
    !messageEl ||
    !viewFullEl
  ) {
    return;
  }


  let currentProduct = null;
  let selectedOptions = [];
  let currentVariant = null;


  /*
   * ==========================================
   * OPEN MODAL
   * ==========================================
   */

  function openModal() {
    modal.classList.add('is-open');

    modal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'quick-view-open'
    );
  }


  /*
   * ==========================================
   * CLOSE MODAL
   * ==========================================
   */

  function closeModal() {
    modal.classList.remove('is-open');

    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'quick-view-open'
    );

    messageEl.textContent = '';
  }


  /*
   * ==========================================
   * FORMAT MONEY
   * ==========================================
   */

  function formatMoney(cents, format) {
    if (
      window.Shopify &&
      typeof Shopify.formatMoney === 'function'
    ) {
      return Shopify.formatMoney(
        cents,
        format
      );
    }

    return '$' + (cents / 100).toFixed(2);
  }


  /*
   * ==========================================
   * FIND VARIANT
   * ==========================================
   */

  function findVariant() {
    if (
      !currentProduct ||
      !currentProduct.variants
    ) {
      return null;
    }

    return currentProduct.variants.find(
      (variant) =>
        variant.options.every(
          (opt, index) =>
            opt === selectedOptions[index]
        )
    );
  }


  /*
   * ==========================================
   * RENDER THUMBNAILS
   * ==========================================
   */

  function renderThumbs() {
    thumbsEl.innerHTML = '';

    if (
      !currentProduct ||
      !currentProduct.images ||
      currentProduct.images.length <= 1
    ) {
      return;
    }

    currentProduct.images.forEach(
      (imgSrc, index) => {
        const thumb =
          document.createElement('button');

        thumb.type = 'button';

        thumb.className =
          'quick-view-modal__thumb';

        if (
          imgSrc === imageEl.src ||
          (index === 0 && !imageEl.src)
        ) {
          thumb.classList.add(
            'is-active'
          );
        }

        const img =
          document.createElement('img');

        img.src = imgSrc;

        img.alt =
          currentProduct.title +
          ' image ' +
          (index + 1);

        thumb.appendChild(img);

        thumb.addEventListener(
          'click',
          () => {
            imageEl.src = imgSrc;

            thumbsEl
              .querySelectorAll(
                '.quick-view-modal__thumb'
              )
              .forEach((t) => {
                t.classList.remove(
                  'is-active'
                );
              });

            thumb.classList.add(
              'is-active'
            );
          }
        );

        thumbsEl.appendChild(thumb);
      }
    );
  }


  /*
   * ==========================================
   * RENDER VARIANTS
   * ==========================================
   */

  function renderVariants() {
    variantsEl.innerHTML = '';

    if (
      !currentProduct ||
      !currentProduct.options
    ) {
      return;
    }

    /*
     * Shopify creates:
     *
     * options: [
     *   {
     *     name: "Title",
     *     values: ["Default Title"]
     *   }
     * ]
     *
     * when a product has no real variants.
     */

    const hasRealOptions =
      currentProduct.options.length > 1 ||
      (
        currentProduct.options.length === 1 &&
        currentProduct.options[0].name
          .toLowerCase() !== 'title'
      );

    if (!hasRealOptions) {
      variantsEl.style.display = 'none';
      return;
    }

    variantsEl.style.display = '';

    currentProduct.options.forEach(
      (option, index) => {
        const group =
          document.createElement('div');

        group.className =
          'quick-view-modal__variant-group';


        const label =
          document.createElement('label');

        label.textContent = option.name;

        group.appendChild(label);


        const select =
          document.createElement('select');

        select.className =
          'quick-view-modal__variant-select';

        select.dataset.index = index;


        option.values.forEach(
          (value) => {
            const opt =
              document.createElement(
                'option'
              );

            opt.value = value;

            opt.textContent = value;

            select.appendChild(opt);
          }
        );


        select.addEventListener(
          'change',
          (event) => {
            selectedOptions[index] =
              event.target.value;

            updateVariant();
          }
        );


        group.appendChild(select);

        variantsEl.appendChild(group);
      }
    );
  }


  /*
   * ==========================================
   * UPDATE VARIANT
   * ==========================================
   */

  function updateVariant() {
    currentVariant =
      findVariant();

    if (currentVariant) {

      /*
       * Update price
       */
      if (
        currentVariant.compare_at_price &&
        currentVariant.compare_at_price >
          currentVariant.price
      ) {
        priceEl.textContent =
          formatMoney(
            currentVariant.price
          ) +
          ' (was ' +
          formatMoney(
            currentVariant.compare_at_price
          ) +
          ')';
      } else {
        priceEl.textContent =
          formatMoney(
            currentVariant.price
          );
      }


      /*
       * Update featured image
       */
      if (
        currentVariant.featured_image
      ) {
        imageEl.src =
          currentVariant.featured_image.src;

        imageEl.alt =
          currentVariant.featured_image.alt ||
          currentProduct.title;


        thumbsEl
          .querySelectorAll(
            '.quick-view-modal__thumb'
          )
          .forEach((thumb) => {

            const thumbImg =
              thumb.querySelector('img');

            thumb.classList.toggle(
              'is-active',
              thumbImg &&
                thumbImg.src ===
                  currentVariant
                    .featured_image
                    .src
            );
          });
      }


      /*
       * Update Add to Cart button
       */
      atcBtn.disabled =
        !currentVariant.available;

      atcText.textContent =
        currentVariant.available
          ? 'Add to Cart'
          : 'Sold Out';

    } else {

      atcBtn.disabled = true;

      atcText.textContent =
        'Unavailable';
    }
  }


  /*
   * ==========================================
   * LOAD PRODUCT
   * ==========================================
   */

  async function loadProduct(
    productUrl
  ) {
    messageEl.textContent = '';

    try {

      /*
       * Fetch Shopify product JSON
       */
      const res = await fetch(
        productUrl + '.js'
      );

      if (!res.ok) {
        throw new Error(
          'Failed to load product'
        );
      }

      currentProduct =
        await res.json();


      /*
       * Product title
       */
      titleEl.textContent =
        currentProduct.title;


      /*
       * Product image
       */
      imageEl.src =
        currentProduct.featured_image ||
        (
          currentProduct.images &&
          currentProduct.images[0]
        ) ||
        '';


      imageEl.alt =
        currentProduct.title;


      /*
       * Reset quantity
       */
      qtyEl.value = 1;


      /*
       * Full product URL
       */
      viewFullEl.href =
        productUrl;


      /*
       * Render thumbnails
       */
      renderThumbs();


      /*
       * Set first variant
       */
      if (
        currentProduct.variants &&
        currentProduct.variants.length
      ) {
        selectedOptions =
          currentProduct
            .variants[0]
            .options
            .slice();
      } else {
        selectedOptions = [];
      }


      /*
       * Render variant selectors
       */
      renderVariants();


      /*
       * Set selector values
       */
      variantsEl
        .querySelectorAll('select')
        .forEach(
          (select, index) => {
            if (
              selectedOptions[index] !==
              undefined
            ) {
              select.value =
                selectedOptions[index];
            }
          }
        );


      /*
       * Update variant
       */
      updateVariant();


      /*
       * Open modal
       */
      openModal();

    } catch (err) {

      console.error(
        'Quick view error:',
        err
      );

      messageEl.textContent =
        'Unable to load product. Please try again.';
    }
  }


  /*
   * ==========================================
   * ADD TO CART
   * ==========================================
   */

  async function addToCart() {
    if (!currentVariant) {
      return;
    }

    atcBtn.disabled = true;

    const originalText =
      atcText.textContent;

    atcText.textContent =
      'Adding...';


    try {

      const quantity =
        parseInt(
          qtyEl.value,
          10
        ) || 1;


      const res =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json'
            },

            body: JSON.stringify({
              id: currentVariant.id,
              quantity: quantity
            })
          }
        );


      if (!res.ok) {

        let errData = {};

        try {
          errData =
            await res.json();
        } catch (e) {
          // Ignore JSON parsing error
        }

        throw new Error(
          errData.description ||
          'Could not add to cart'
        );
      }


      /*
       * Success
       */
      messageEl.textContent =
        'Added to cart!';

      atcText.textContent =
        originalText;

      atcBtn.disabled = false;


      /*
       * Notify other cart scripts
       */
      document.dispatchEvent(
        new CustomEvent(
          'cart:updated'
        )
      );

    } catch (err) {

      console.error(
        'Add to cart error:',
        err
      );

      messageEl.textContent =
        err.message ||
        'Could not add to cart.';

      atcText.textContent =
        originalText;

      atcBtn.disabled = false;
    }
  }


  /*
   * ==========================================
   * QUICK VIEW CLICK
   * ==========================================
   */

  document.addEventListener(
    'click',
    (event) => {

      const btn =
        event.target.closest(
          '[data-quickview]'
        );


      if (btn) {
        event.preventDefault();

        const productUrl =
          btn.dataset.productUrl;

        if (productUrl) {
          loadProduct(
            productUrl
          );
        }

        return;
      }


      /*
       * Close button
       */
      if (
        event.target.closest(
          '[data-qv-close]'
        )
      ) {
        closeModal();
      }
    }
  );


  /*
   * ==========================================
   * ESCAPE KEY
   * ==========================================
   */

  document.addEventListener(
    'keydown',
    (event) => {

      if (
        event.key === 'Escape' &&
        modal.classList.contains(
          'is-open'
        )
      ) {
        closeModal();
      }
    }
  );


  /*
   * ==========================================
   * ADD TO CART BUTTON
   * ==========================================
   */

  atcBtn.addEventListener(
    'click',
    addToCart
  );

})();